import React, { useState, useEffect } from 'react';
import { useSpring, config, animated } from 'react-spring';
import PropTypes from 'prop-types';
import NavBar from './components/NavBar';
import Content from './components/Content';
import ArrowDown from './components/ArrowDown';
import SocialLink from '../components/SocialLink';

// import DP from '../../assets/images/dp-logo-100.png';

import './Header.scss';

const NavBarBrand = () => {
  return (
    <a className="navbar-brand p-0" rel="noreferrer" href="#home">
      <div className="dp">
        <span>Dickson</span>&nbsp;<span>Palomeras</span>
      </div>
      {/* <div className="d-none d-md-block">
        <div className="dp">
          <span>Dickson</span>&nbsp;<span>Palomeras</span>
        </div>
      </div>
      <div className="d-block d-md-none">
        <div className="dp">
          <span>D</span>&nbsp;<span>P</span>
        </div>
      </div> */}
    </a>
  );
};

const DpSvgLogo = () => (
  <svg
    width="1024"
    height="1024"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className="dp-logo"
  >
    <text x="-3.7%" y="336" stroke="#f8f8f8" fill="#1f1f1f">
      D
    </text>
    <text x="42%" y="460" stroke="#f8f8f8" fill="#1f1f1f">
      P
    </text>
  </svg>
);

function Header({
  id,
  navItems,
  isMobile,
  isSideBarOpen,
  setIsSideBarOpen,
  ...props
}) {
  const [profilePicUrl, setProfilePicUrl] = useState('');

  useEffect(() => {
    const fetchImg = async () => {
      const url = await fetch('./assets/images/me.png').then((res) => res.url);
      setProfilePicUrl(url);
    };
    fetchImg();
  }, []);

  const socialStyles = useSpring({
    config: { ...config.wobbly },
    from: { y: 200 },
    to: { y: 0 },
  });

  let options = {
    navBrand: <NavBarBrand />,
    navItems,
    className: 'mb-auto',
    isMobile,
    isSideBarOpen,
    setIsSideBarOpen,
  };

  return (
    <header id={id} className="d-flex flex-column line-bottom" {...props}>
      <NavBar {...options} />
      <Content picture={profilePicUrl} />
      <animated.div
        className="position-sticky mt-auto"
        style={{ ...socialStyles }}
      >
        <SocialLink childClassName="mx-4 mx-md-5" />
      </animated.div>
      <ArrowDown />
      <DpSvgLogo />
    </header>
  );
}

Header.defaultProps = {
  id: 'home',
  navItems: [],
  isMobile: false,
};

Header.propTypes = {
  id: PropTypes.string,
  navItems: PropTypes.array,
  isMobile: PropTypes.bool,
};

export default React.memo(Header);
